import { Link } from 'react-router-dom';
import ArticleLayout from '@/components/ArticleLayout';

const guides = [
  { title: 'CSSBuy Review 2026', to: '/reviews/cssbuy-review', desc: 'Comprehensive review covering fees, QC, shipping, and warehouse features.' },
  { title: 'Is CSSBuy Legit?', to: '/reviews/is-cssbuy-legit', desc: 'Safety analysis of CSSBuy legitimacy, payments, and scam prevention.' },
  { title: 'CSSBuy Shipping Cost Guide', to: '/shipping/cssbuy-shipping-cost', desc: 'Complete guide to shipping factors, costs, and tips.' },
  { title: 'CSSBuy Warehouse Guide', to: '/warehouse/cssbuy-warehouse', desc: 'Understanding the warehouse process, storage, and consolidation.' },
  { title: 'CSSBuy QC Guide', to: '/qc/cssbuy-qc-guide', desc: 'How to review quality control photos and inspect items.' },
  { title: 'CSSBuy Coupon Guide', to: '/coupon/cssbuy-coupon', desc: 'Finding and verifying discount codes and promotions.' },
];

export default function GuidesPage() {
  return (
    <ArticleLayout
      title="CSSBuy Guides"
      description="Comprehensive guides for using CSSBuy, shipping, quality control, warehouse, and more."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Guides', to: '/guides' },
      ]}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {guides.map((guide) => (
          <Link
            key={guide.to}
            to={guide.to}
            className="group p-5 bg-background-50 border border-background-200 rounded-xl hover:bg-primary-50 hover:border-primary-200 transition-all"
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 group-hover:bg-primary-200 flex items-center justify-center shrink-0 transition-colors">
                <i className="ri-book-open-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-700 mb-1">
                  {guide.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{guide.desc}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </ArticleLayout>
  );
}